module.exports = __webpack_public_path__ + "static/media/icon-manage-class-student.c72ea052.svg";